import { PUBLIC_API_BASE_PATH } from 'src/constants/environment';
import type { TaxonomyPlpNeighborhoodEntry } from 'src/services/contentstack/taxonomyNeighborhood/types';
import { logger } from 'src/utils/serverLogger';
import { encodePathQueryParam } from './encodePathQueryParam';

/** Client-side fetch of the neighbourhood map via the public API route. */
export const fetchNeighborhoodMap = async (
  path: string,
): Promise<TaxonomyPlpNeighborhoodEntry[]> => {
  try {
    const res = await fetch(
      `${PUBLIC_API_BASE_PATH}taxonomy-content-entries?path=${encodePathQueryParam(path)}`,
    );

    if (!res.ok) {
      logger.error('fetchNeighborhoodMap: non-ok response', { path, status: res.status });

      return [];
    }

    const data = (await res.json()) as { entries?: TaxonomyPlpNeighborhoodEntry[] };

    return data.entries ?? [];
  } catch (error) {
    logger.error('fetchNeighborhoodMap: request failed', {
      path,
      message: error instanceof Error ? error.message : String(error),
    });

    return [];
  }
};
